/**
 * Feature permission information
 */
export interface FeaturePermissionInfo {
    /** Feature code (e.g., FTO_ADVANCED_FILTER) */
    feature_code: string;
    /** Feature display name */
    feature_name: string;
    /** Whether the feature is visible */
    visible: boolean;
    /** Whether the feature is available (false means upgrade needed) */
    available: boolean;
    /** Visible data count limit, -1 means unlimited */
    visible_data_count: number;
    /** Remaining quota, -1 means unlimited, null means no quota limit */
    remaining_quota: number | null;
    /** Remaining task quota, -1 means unlimited, null means no task quota limit */
    remaining_task_quota: number | null;
}

/**
 * Combined request parameters for queryFeaturePermissions API
 */
export interface QueryFeaturePermissionsRequest {
    /** Task ID */
    task_id: string;
    /** Task type: AI_FTO_SEARCH, AI_NOVELTY_SEARCH, AI_SPECIFICATION, etc. */
    task_type: 'AI_FTO_SEARCH' | 'AI_NOVELTY_SEARCH' | 'AI_SPECIFICATION';
}

/**
 * Response data interface for queryFeaturePermissions API
 */
export interface QueryFeaturePermissionsResponse {
    /** Task ID */
    task_id: string;
    /** Task type */
    task_type: string;
    /** User tier (e.g., PRO) */
    user_tier: string;
    /** List of feature permissions */
    features: FeaturePermissionInfo[];
    /**
     * 当前登录人是否为任务创建人
     */
    is_owner: boolean;
}

/**
 * API interface for queryFeaturePermissions
 */
export interface QueryFeaturePermissionsApi {
    /**
   * Query feature permissions for a task
   *
   * @param params - Request parameters including task ID and task type
   * @returns Promise resolving to response data with feature permissions
   */
    queryFeaturePermissions(params: QueryFeaturePermissionsRequest): Promise<QueryFeaturePermissionsResponse>;
}

/**
 * Symbol for dependency injection
 */
export const QueryFeaturePermissionsApi = Symbol.for('QueryFeaturePermissionsApi');
